
import React, { useState, MouseEvent } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Popover
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel,
        FileInfoType} from '../../models/models';
import {validateEmailField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import Config from "../../config";


const FilePreview: React.FC<{
  file: FileInfoType | null
}> = ({
  file
}) => {

  let mediaServiceUrl = undefined;
  if(file?.url){
    mediaServiceUrl = `${Config.getInstance().getCoordinationServiceURL()}${file?.url}`;
  }

  if(file?.mimetype?.startsWith('image/')){
    return (
      <Box sx={{ p: 1, maxWidth: 600, maxHeight: 600 }}>
        <img
          src={mediaServiceUrl}
          alt={file?.filename}
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            maxHeight: 260,
            objectFit: 'contain',
            borderRadius: 4,
          }}
        />
      </Box>
    )
  } else if(file?.mimetype === "application/pdf"){
    return null
  } else if(file?.mimetype?.startsWith('video/')){
    return null
  }

  return null
}



export const FileFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: any,
  onChange: (value: File, layoutField: LayoutFieldModel) => void,
  onDownload: (layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange,
  onDownload
}) => {

  const thisFile = value as FileInfoType | null;

  const styles = ContainerClasses();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const required = checkLayoutFieldRequirement(layoutField);

  const handleDownload = (layoutField: LayoutFieldModel) => {
    onDownload(layoutField)
  }

  const handleFileChange = (event: any) => {

    const selectedFile = event.target.files[0]
    if(!selectedFile) return;
    onChange(selectedFile, layoutField)

  }

  const handlePreviewEnter = (e: MouseEvent<HTMLElement>) => {
    //for now, only set anchor element when image
    const target = e.target as HTMLElement;
    if (target.closest('button')) {
      setAnchorEl(null)
      return; // ignore hover over download/upload icon buttons
    }

    if(thisFile?.mimetype?.startsWith('image/')){
      setAnchorEl(e.currentTarget);
    }
  };
  const handlePreviewLeave = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  const error = () => {
    if(required &&
       (!value)){
         return true
       }
    return false
  };



  return (
    <Box
      onMouseLeave={handlePreviewLeave}
      onMouseEnter={handlePreviewEnter}
      sx={{
        display: 'inline-block',
        width: '100%'
      }}
    >
      <TextField
         fullWidth
         error={error()}
         disabled
         rows={1}
         required={required}
         size="small"
         label={layoutField.ReferencedField_sys.Label_sys}
         variant="filled"
         value={thisFile?.filename}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
           onClick: () => console.log("field clicked")
         }}
         InputProps={{
           disableUnderline: true,
           startAdornment:(
              <InputAdornment position="start">
                <IconButton
                   disabled={thisFile === (undefined || null) ? true : false}
                   size="small"
                   onClick={() => handleDownload(layoutField)}>
                     <FileDownloadIcon />
                 </IconButton>
            </InputAdornment>
           ),
           endAdornment: (
             layoutField.AccessSetting_sys !== 'read' &&
              <InputAdornment position="end">
                 <IconButton size="small" component="label">
                 <FileUploadIcon/>
                 <input
                    type="file"
                    hidden
                    onChange={(e) => handleFileChange(e)}
                  />
                </IconButton>
            </InputAdornment>
        ),
         }}
      />

      <Popover
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={handlePreviewLeave}
        disableRestoreFocus
        disableScrollLock
      >
        {
          thisFile &&
          <FilePreview
            file={thisFile}
          />
        }

      </Popover>

    </Box>
    );

};
